import { Button, Form, Modal, ProgressBar } from "react-bootstrap";
import Multiselect, { components } from "react-select";
import CountryService from "../../services/country.service";
import { useState, useRef } from "react";
import {
  Box,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import RaceService from "../../services/race.service";
import { useFormik } from "formik";
import { useEffect } from "react";
import useDialogState from "../../hooks/useDialog";
import StandingService from "../../services/standing.service";
import HighScoreService from "../../services/hiscore.service";
import { enqueueSnackbar } from "notistack";
import { HashLoader } from "react-spinners";
import excelSheet from "../../excel/player11.xlsx";
import excelResult11 from "../../excel/result11.xlsx";
import excelResult19 from "../../excel/result19.xlsx";
import excelStanding from "../../excel/standing file.xlsx";
import worldwide from "../../excel/worldwide.xlsx";
import continents from "../../excel/continents.xlsx";
import countrys from "../../excel/worldwide.xlsx";
import FeedbackService from "../../services/feeback.service";
import UserService from "../../services/user.service";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { SketchPicker } from "react-color";
import ColorCodeService from "../../services/coloeCode.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette } from "@fortawesome/free-solid-svg-icons";
import CountryCodeService from "../../services/countryCode.service";
import ImageService from "../../services/setting.service";
import GroupService from "../../services/group.service";
import { useSnackbar } from "notistack";
import SeasonsService from "../../services/season.service";

const handleDownload = () => {
  const fileUrl = excelSheet;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "player.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleesultDownload = () => {
  const fileUrl = excelResult11;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "result11.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleesult19Download = () => {
  const fileUrl = excelResult19;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "result19.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadStanding = () => {
  const fileUrl = excelStanding;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "standing.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const worldWide = () => {
  const fileUrl = worldwide;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "worldWide.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const continent = () => {
  const fileUrl = continents;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "continent.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const country = () => {
  const fileUrl = countrys;
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "country.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function AddRace(props) {
  const {
    formik,
    handleFileUpload,
    openCity,
    handleOpenCity,
    handleCloseCity,
    openCity2,
    handleOpenCity2,
    handleCloseCity2,
    update,
    changeCountry,
    contryStatus,
    handleRadioChange,
    loader,
    handleDateChnage,
    changeSeason,
    ColorStatus,
    checkStatus,
    type,
    modelLoader
  } = props;
  console.log("ColorStatus", ColorStatus)

  const sortedOptions = contryStatus
    ?.slice()
    ?.sort((a, b) => a.label.localeCompare(b.local));

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton onClick={formik.resetForm} />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <>
                <form onSubmit={formik.handleSubmit}>
                  <h4>{update ? "Update Race" : "Create Race"}</h4>
                  <div className="col-12">
                    <Form.Group
                      controlid="validationFormik101"
                      className="position-relative">
                      <Box sx={{ display: "flex" }}>
                        <div
                          style={{
                            display: "block",
                            width: "45%",
                          }}>
                          <Form.Label
                            style={{
                              textAlign: "start",
                              color: "#000",
                              marginTop: "15px",
                            }}>
                            Select Country :{" "}
                            <span className="tx-danger"> *</span>
                          </Form.Label>
                          <Multiselect
                            classNamePrefix="Select2 z-index-10"
                            options={sortedOptions}
                            singleSelect
                            name="countryId"
                            isDisabled={
                              checkStatus === "finished" ||
                              checkStatus === "active"
                            }
                            onChange={changeCountry}
                            isSearchable
                            menuIsOpen={openCity}
                            onMenuOpen={handleOpenCity}
                            onMenuClose={handleCloseCity}
                            value={contryStatus?.find(
                              (option) =>
                                option.value === formik.values.countryId
                            )}
                          />
                          {formik.errors.countryId &&
                            formik.touched.countryId ? (
                            <p
                              classtype="text-start error"
                              style={{ color: "red", textAlign: "start" }}>
                              {formik.errors.countryId}
                            </p>
                          ) : null}
                        </div>
                        <div
                          style={{
                            marginLeft: "auto",
                            display: "block",
                            width: "45%",
                          }}>
                          <Form.Label
                            style={{
                              textAlign: "start",
                              color: "#000",
                              marginTop: "15px",
                            }}>
                            Race Name :<span className="tx-danger"> *</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="raceName"
                            disabled={
                              checkStatus === "finished" ||
                              checkStatus === "active"
                            }
                            placeholder="Race Name"
                            value={formik.values.raceName}
                            onChange={formik.handleChange}
                          />
                          {formik.errors.raceName && formik.touched.raceName ? (
                            <p
                              classtype="text-start error"
                              style={{ color: "red", textAlign: "start" }}>
                              {formik.errors.raceName}
                            </p>
                          ) : null}
                        </div>
                      </Box>
                      <Form.Label
                        style={{
                          textAlign: "start",
                          color: "#000",
                          marginTop: "15px",
                        }}>
                        Spotify Link:
                        <span className="tx-danger"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="spotifyUrl"
                        placeholder="Spotify Link"
                        value={formik.values.spotifyUrl}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.spotifyUrl && formik.touched.spotifyUrl ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.spotifyUrl}
                        </p>
                      ) : null}
                      <Form.Label
                        style={{
                          textAlign: "start",
                          color: "#000",
                          marginTop: "15px",
                        }}>
                        Select Season Name :{" "}
                        <span className="tx-danger"> *</span>
                      </Form.Label>
                      <Multiselect
                        classNamePrefix="Select2 z-index-10"
                        options={ColorStatus}
                        singleSelect
                        isDisabled={
                          checkStatus === "finished" || checkStatus === "active"
                        }
                        name="colorCodeId"
                        onChange={changeSeason}
                        isSearchable
                        menuIsOpen={openCity2}
                        onMenuOpen={handleOpenCity2}
                        onMenuClose={handleCloseCity2}
                        value={ColorStatus?.find(
                          (option) => option.value === formik.values.colorCodeId
                        )}
                      />
                      {formik.errors.colorCodeId &&
                        formik.touched.colorCodeId ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.colorCodeId}
                        </p>
                      ) : null}
                      <Form.Label
                        style={{
                          textAlign: "start",
                          color: "#000",
                          marginTop: "15px",
                        }}>
                        Select Match Time:
                        <span className="tx-danger"> *</span>
                      </Form.Label>
                      <div style={{ display: "flex", justifyContent: "start" }}>
                        <DatePicker
                          style={{
                            padding: "18px 111px",
                            border: "1px solid #e8e8f7",
                            textAlign: "center",
                          }}
                          disabled={checkStatus === "finished" && true}
                          value={formik.values.startingTime}
                          onChange={(date) => handleDateChnage(date)}
                          format="DD-MM-YYYY HH:mm:ss"
                          placeholder={
                            update
                              ? formik.values.startingTime
                              : "Select Match Time"
                          }
                          name="startingTime"
                          minDate={new Date()}
                          plugins={[<TimePicker position="top" />]}
                        />
                      </div>
                      {formik.errors.startingTime &&
                        formik.touched.startingTime ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.startingTime}
                        </p>
                      ) : null}
                      <Form.Label
                        style={{
                          textAlign: "start",
                          color: "#000",
                          marginTop: "15px",
                        }}>
                        Year :<span className="tx-danger"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="year"
                        disabled={
                          checkStatus === "finished" || checkStatus === "active"
                        }
                        placeholder="Year"
                        value={formik.values.year}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.year && formik.touched.year ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.year}
                        </p>
                      ) : null}
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="isElevenQuestions"
                        value={formik.values.isElevenQuestions}
                        sx={{
                          marginTop: "10px",
                        }}>
                        {type === "f1" && (
                          <Box sx={{ display: "flex" }}>
                            <FormControlLabel
                              value={true}
                              control={<Radio />}
                              disabled={
                                checkStatus === "finished" ||
                                checkStatus === "active"
                              }
                              label="10 Member of team"
                              onChange={() => handleRadioChange(true, 10)}
                            />
                            <FormControlLabel
                              value={false}
                              control={<Radio />}
                              disabled={checkStatus === "finished" && true}
                              label="18 Member of team"
                              onChange={() => handleRadioChange(false, 18)}
                            />
                          </Box>
                        )}
                        {type === "moto_gp" && (
                          <Box sx={{ display: "flex" }}>
                            <FormControlLabel
                              value={true}
                              control={<Radio />}
                              disabled={
                                checkStatus === "finished" ||
                                checkStatus === "active"
                              }
                              label="24 Member of team"
                              checked={true}
                            // onChange={() => handleRadioChange(true, 24)}
                            />
                          </Box>
                        )}
                      </RadioGroup>
                      {formik.errors.isElevenQuestions &&
                        formik.touched.isElevenQuestions ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.isElevenQuestions}
                        </p>
                      ) : null}
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Form.Label className="text-start text-black font-weight-bold">
                            Download Excel File for Your Refrence :
                          </Form.Label>
                          <Button
                            onClick={handleDownload}
                            style={{ marginLeft: "auto", marginRight: "15px" }}>
                            <i className="fas fa-download"></i> Download
                          </Button>
                        </div>

                        <Form.Label className="text-start text-black">
                          Player Detail <span className="tx-danger"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="file"
                          disabled={
                            checkStatus === "finished" ||
                            checkStatus === "active"
                          }
                          name="data"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          placeholder="Choose a file"
                          onChange={(e) => handleFileUpload(e)}
                        />
                        {formik.errors.data && formik.touched.data ? (
                          <p
                            classtype="text-start error"
                            style={{ color: "red", textAlign: "start" }}>
                            {formik.errors.data}
                          </p>
                        ) : null}
                      </>
                    </Form.Group>
                  </div>

                  <div>
                    <Button
                      type="submit"
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "15px",
                        marginTop: "15px",
                      }}>
                      {update ? modelLoader ? "Updating..." : "Update" : modelLoader ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export const PlayerEdit = (props) => {
  const { update, formik, loader, contryStatus, changeCountry, openCity, handleOpenCity, handleCloseCity, data, currentPlayerId } = props;

  const sortedOptions = contryStatus
    ?.slice()
    ?.sort((a, b) => a.label.localeCompare(b.local));

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>{update ? "Edit Player" : "Add Player"}</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Player Name:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="playerName"
                      placeholder="Player Name"
                      value={formik.values.playerName}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.playerName && formik.touched.playerName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.playerName}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Player Car:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="playerInfo"
                      placeholder="Player Car"
                      value={formik.values.playerInfo}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.playerInfo && formik.touched.playerInfo ? (
                      <p className="text-start error">
                        {formik.errors.playerInfo}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Player Order:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="playerOrder"
                      placeholder="Player Order"
                      value={formik.values.playerOrder}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (!isNaN(value) && value !== "") {
                          const numericValue = Number(value);
                          formik.setFieldValue(e.target.name, numericValue);

                          // Manual duplicate check
                          const isDuplicate = data.some(item =>
                            item.playerOrder === numericValue && item.id !== currentPlayerId
                          );

                          if (isDuplicate) {
                            formik.setFieldError('playerOrder', 'This player order already exists');
                          } else {
                            formik.setFieldError('playerOrder', '');
                          }
                        } else {
                          formik.setFieldError('playerOrder', '');
                          formik.setFieldValue(e.target.name, "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.playerOrder && !!formik.errors.playerOrder}
                    />
                    {formik.errors.playerOrder && formik.touched.playerOrder ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.playerOrder}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Country : <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10 cursor-pointer"
                      options={sortedOptions}
                      singleSelect
                      name="playerCountry"
                      onChange={changeCountry}
                      isSearchable
                      menuIsOpen={openCity}
                      onMenuOpen={handleOpenCity}
                      onMenuClose={handleCloseCity}
                      value={contryStatus?.find(
                        (option) =>
                          option.label === formik.values.playerCountry
                      )}
                    />
                    {formik.errors.playerCountry ||
                      formik.touched.playerCountry ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.playerCountry}
                      </p>
                    ) : null}

                  </Form.Group>
                </div>

                <div>
                  {loader ? (
                    <CircularProgress
                      size={30}
                      style={{
                        color: "#000",
                        marginLeft: "auto",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    <>
                      <Button
                        type="submit"
                        style={{
                          display: "flex",
                          marginLeft: "auto",
                          marginRight: "15px",
                          marginTop: "15px",
                        }}>
                        {update ? "Update" : "Submit"}
                      </Button>
                    </>
                  )}
                </div>
              </form>
            )}s
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const PredictRace = (props) => {
  const { update, formik, loader, handleFileUpload, showLink, languageStatus, changeLanguage, openCity, handleOpenCity, handleCloseCity } = props;
  console.log("formik", formik.values.languageImagePairs)
  const sortedOptions = languageStatus
    ?.slice()
    ?.sort((a, b) => a.label.localeCompare(b.local));

  // Track initial language values and pairs with IDs when in update mode
  const [initialLanguageValues, setInitialLanguageValues] = useState([]);
  const [initialLanguagePairs, setInitialLanguagePairs] = useState([]);
  const hasCapturedInitialRef = useRef(false);

  useEffect(() => {
    if (update && formik.values.language && formik.values.language.length > 0 && !hasCapturedInitialRef.current) {
      // Store initial language values (by value property) when component mounts in update mode
      const initialValues = formik.values.language.map(lang => lang.value || lang);
      setInitialLanguageValues(initialValues);
      // Store initial language pairs with their IDs for API calls
      if (formik.values.languageImagePairs && formik.values.languageImagePairs.length > 0) {
        setInitialLanguagePairs(formik.values.languageImagePairs);
      }
      hasCapturedInitialRef.current = true;
    } else if (!update) {
      // Reset when not in update mode
      setInitialLanguageValues([]);
      setInitialLanguagePairs([]);
      hasCapturedInitialRef.current = false;
    }
  }, [update, formik.values.language, formik.values.languageImagePairs]);

  // Handler to detect removed languages and call delete API
  const handleLanguageChange = async (selectedOptions) => {
    if (update && formik.values.language && formik.values.language.length > 0) {
      const previousValues = formik.values.language.map(lang => lang.value || lang);
      const newValues = selectedOptions ? selectedOptions.map(lang => lang.value || lang) : [];

      // Find removed languages (in previous but not in new)
      const removedValues = previousValues.filter(val => !newValues.includes(val));

      // For each removed language, find its languageImageId and call delete API
      if (removedValues.length > 0 && formik.values.id) {
        for (const removedValue of removedValues) {
          // Find the pair that matches this language value
          const removedPair = initialLanguagePairs.find(
            pair => (pair.language?.value || pair.language) === removedValue
          );

          // If the pair has an _id (languageImageId), call the delete API
          if (removedPair && removedPair._id) {
            try {
              await ImageService.DeleteLanguageRace(formik.values.id, removedPair._id);
            } catch (error) {
              console.error("Error deleting language race:", error);
            }
          }
        }
      }
    }

    // Call the original changeLanguage function
    changeLanguage(selectedOptions);
  };

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>Upload Your Image</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Name:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <p className="text-start error"> {formik.errors.name}</p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Index:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="index"
                      placeholder="Index"
                      value={formik.values.index}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.index && formik.touched.index ? (
                      <p className="text-start error"> {formik.errors.index}</p>
                    ) : null}

                    {showLink === 4 && (
                      <>
                        {" "}
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                          }}>
                          Add Website Link:
                          <span className="tx-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="link"
                          placeholder="Website Link"
                          value={formik.values.link}
                          onChange={formik.handleChange}
                        />
                        {formik.errors.link && formik.touched.link ? (
                          <p className="text-start error">
                            {" "}
                            {formik.errors.link}
                          </p>
                        ) : null}
                      </>
                    )}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Language:<span className="tx-danger">*</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10 cursor-pointer"
                      options={sortedOptions}
                      isMulti
                      name="language"
                      isSearchable
                      menuIsOpen={openCity}
                      onMenuOpen={handleOpenCity}
                      onMenuClose={handleCloseCity}
                      onChange={handleLanguageChange}
                      value={formik.values.language}
                    />

                    {formik.errors.language &&
                      formik.touched.language ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.language}
                      </p>
                    ) : null}

                    {/* Dynamic Language-Image Pairs */}
                    {formik.values.languageImagePairs && formik.values.languageImagePairs.length > 0 && (
                      <div style={{ marginTop: "20px" }}>
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}>
                          Select Images for Each Language:<span className="tx-danger">*</span>
                        </Form.Label>
                        {formik.values.languageImagePairs.map((pair, index) => (
                          <div key={index} style={{ marginBottom: "20px", padding: "15px", border: "1px solid #ddd", borderRadius: "5px" }}>
                            <Form.Label
                              style={{
                                textAlign: "start",
                                color: "#000",
                                marginBottom: "10px",
                                fontWeight: "bold",
                              }}>
                              {index + 1}. {pair.language?.label || ""} - Select Image:
                              <span className="tx-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="file"
                              name={`files_${index}`}
                              placeholder="Choose a file"
                              accept="image/*"
                              onChange={(e) => handleFileUpload(index, e)}
                            />
                            {pair.file && typeof pair.file === 'string' && (
                              <div style={{ marginTop: "10px" }}>
                                <img
                                  src={pair.file}
                                  alt="Preview"
                                  style={{ maxWidth: "100px", maxHeight: "100px", borderRadius: "5px" }}
                                />
                              </div>
                            )}
                            {pair.file && pair.file instanceof File && (
                              <div style={{ marginTop: "10px" }}>
                                <img
                                  src={URL.createObjectURL(pair.file)}
                                  alt="Preview"
                                  style={{ maxWidth: "100px", maxHeight: "100px", borderRadius: "5px" }}
                                />
                              </div>
                            )}

                          </div>
                        ))}
                        {formik.errors.languageImagePairs &&
                          typeof formik.errors.languageImagePairs === 'string' && (
                            <p
                              className="text-start error"
                              style={{ color: "red", textAlign: "start" }}>
                              {formik.errors.languageImagePairs}
                            </p>
                          )}
                      </div>
                    )}
                  </Form.Group>
                </div>

                <div>
                  {loader ? (
                    <CircularProgress
                      size={30}
                      style={{
                        color: "#000",
                        marginLeft: "auto",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    <>
                      <Button
                        type="submit"
                        style={{
                          display: "flex",
                          marginLeft: "auto",
                          marginRight: "15px",
                          marginTop: "15px",
                        }}>
                        {update ? "Update" : "Submit"}
                      </Button>
                    </>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const CountryCodeModal = (props) => {
  const { formik, loader, handleFileUpload, getSingleImage } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait</h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>Country Code</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Country Name:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="countryName"
                      placeholder="Country Name"
                      value={formik.values.countryName}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.countryName && formik.touched.countryName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.countryName}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Country Code:
                      <span className="tx-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="countryCode"
                      placeholder="Country Code"
                      value={formik.values.countryCode}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.countryCode && formik.touched.countryCode ? (
                      <p className="text-start error">
                        {formik.errors.countryCode}
                      </p>
                    ) : null}
                    <Form.Label
                      className="text-start text-black"
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select File <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      name="files"
                      placeholder="Choose a file"
                      onChange={(e) => handleFileUpload(e)}
                    />
                    {formik.errors.files && formik.touched.files ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.files}
                      </p>
                    ) : null}
                    {getSingleImage ? (
                      <>
                        <div
                          style={{
                            height: "250px",
                            width: "350px",
                          }}>
                          <img
                            src={getSingleImage}
                            style={{ borderRadius: "11px" }}
                            alt={""}
                            className="img-fit-cover mt-3"
                          />
                        </div>
                      </>
                    ) : null}
                  </Form.Group>
                </div>

                <div>
                  {loader ? (
                    <CircularProgress
                      size={30}
                      style={{
                        color: "#000",
                        marginLeft: "auto",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    <>
                      <Button
                        type="submit"
                        style={{
                          display: "flex",
                          marginLeft: "auto",
                          marginRight: "15px",
                          marginTop: "15px",
                        }}>
                        Submit
                      </Button>
                    </>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const SettingModule = (props) => {
  const { onHide, id, languageImageId, getAllData } = props;
  const [loader, setLoader] = useState(false);

  const deleteRace = async () => {
    setLoader(true);

    if (id && languageImageId === undefined) {
      await ImageService.ImageDelete(id);
    } else if (id && languageImageId) {
      await ImageService.DeleteLanguageRace(languageImageId, id);
    }
    onHide();
    getAllData();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete Race Result !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteRace}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const UsreEdit = (props) => {
  const {
    formik,
    loader,
    contryStatus,
    // changeStatus,
    openCity,
    handleOpenCity,
    handleCloseCity,
    openCity2,
    handleOpenCity2,
    handleCloseCity2,
    handleFieldChange,
    CountryStatus,
    update,
    handleChange,
    CountryCode,
    changeCountryCode,
  } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>{update ? "Update User" : "Add User"}</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      User Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="userName"
                      placeholder="User Name"
                      value={formik.values.userName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("userName", e.target.value);
                      }}
                    />
                    {formik.errors.userName && formik.touched.userName ? (
                      <p className="text-start error">
                        {formik.errors.userName}
                      </p>
                    ) : null}
                    {!update && (
                      <>
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                          }}>
                          Password<span className="tx-danger"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="password"
                          // value={formik.values.password}
                          placeholder="Password"
                          onChange={formik.handleChange}
                        />
                        {formik.errors.password && formik.touched.password ? (
                          <p className="text-start error">
                            {formik.errors.password}
                          </p>
                        ) : null}
                      </>
                    )}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      First Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formik.values.firstName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("firstName", e.target.value);
                      }}
                    />
                    {formik.errors.firstName && formik.touched.firstName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.firstName}
                      </p>
                    ) : null}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Last Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formik.values.lastName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("lastName", e.target.value);
                      }}
                    />
                    {formik.errors.lastName && formik.touched.lastName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.lastName}
                      </p>
                    ) : null}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Nationality<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10"
                      options={CountryStatus}
                      singleSelect
                      name="nationality"
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          formik.setFieldValue(
                            "nationality",
                            selectedOption.label
                          );
                        }
                      }}
                      isSearchable
                      menuIsOpen={openCity2}
                      onMenuOpen={handleOpenCity2}
                      onMenuClose={handleCloseCity2}
                      value={CountryStatus?.find(
                        (data) => data.label === formik.values.nationality
                      )}
                    />
                    {formik.errors.nationality && formik.touched.nationality ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.nationality}
                      </p>
                    ) : null}
                    {!update && (
                      <>
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                          }}>
                          Email
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="email"
                          placeholder="Email"
                          value={formik.values.email}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                        />
                      </>
                    )}
                    {!update && (
                      <>
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                          }}>
                          Mobile Number
                        </Form.Label>
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "150px" }}>
                            <Multiselect
                              classNamePrefix="Select2 z-index-10"
                              options={CountryCode}
                              singleSelect
                              name="countryCode"
                              onChange={changeCountryCode}
                              isSearchable
                              menuIsOpen={openCity}
                              onMenuOpen={handleOpenCity}
                              onMenuClose={handleCloseCity}
                            // value={contryStatus?.find(
                            //   (option) => option.value === formik.values.roles
                            // )}
                            />
                          </div>
                          <Form.Control
                            type="number"
                            name="mobileNumber"
                            placeholder="Number"
                            style={{ marginLeft: "10px" }}
                            value={formik.values.mobileNumber}
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                          />
                        </div>
                      </>
                    )}
                  </Form.Group>
                </div>

                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const AddSeason = (props) => {
  const { formik, loader, handleFieldChange, update } = props;
  const currentYear = new Date().getFullYear();
  const yearsList = [];
  for (let y = 2040; y >= 1900; y--) {
    yearsList.push(y);
  }

  const options = yearsList?.map((year) => ({
    label: year,
    value: year,
  }));

  const selectedOption =
    options?.find((option) => option.value == formik.values.year) || null;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>{update ? "Update Season" : "Add Season"}</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Season Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Season Name"
                      value={formik.values.name}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("name", e.target.value);
                      }}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <p className="text-start error">{formik.errors.name}</p>
                    ) : null}
                  </Form.Group>
                </div>

                <div className="col-12">
                  <Form.Label className="text-start text-black mt-3">
                    Year <span className="tx-danger"> *</span>
                  </Form.Label>
                  <Multiselect
                    classNamePrefix="Select2 z-index-10 pointer "
                    value={selectedOption}
                    options={options}
                    singleSelect
                    name="year"
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        formik.setFieldValue(
                          "year",
                          String(selectedOption.value)
                        );
                      }
                    }}
                    isSearchable
                  />
                </div>
                {formik.errors.year && formik.touched.year ? (
                  <p
                    className="text-start error"
                    style={{
                      color: "#dc3545",
                      fontSize: "0.875rem",
                      marginTop: "5px",
                      marginLeft: "15px",
                    }}>
                    {formik.errors.year}
                  </p>
                ) : null}
                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export const AddMember = (props) => {
  const {
    formik,
    loader,
    userData,
    openCity2,
    handleOpenCity2,
    handleCloseCity2,
  } = props;
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>{"Add Member"}</h4>
                <div className="col-12">
                  <Form.Label
                    style={{
                      textAlign: "start",
                      color: "#000",
                      marginTop: "15px",
                    }}>
                    User Name<span className="tx-danger"> *</span>
                  </Form.Label>
                  <Multiselect
                    classNamePrefix="Select2 z-index-10 pointer "
                    options={userData}
                    singleSelect
                    name="nationality"
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        formik.setFieldValue(
                          "memberName",
                          selectedOption.label
                        );
                        formik.setFieldValue("id", selectedOption.id);
                      }
                    }}
                    isSearchable
                    menuIsOpen={openCity2}
                    onMenuOpen={handleOpenCity2}
                    onMenuClose={handleCloseCity2}
                    value={userData?.find(
                      (data) => data.label === formik.values.memberName
                    )}
                  />
                </div>
                {formik.errors.memberName ? (
                  <p
                    className="text-start error"
                    style={{
                      color: "#dc3545",
                      fontSize: "0.875rem",
                      marginTop: "5px",
                      marginLeft: "15px",
                    }}>
                    {formik.errors.memberName}
                  </p>
                ) : null}
                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const StandingEdit = (props) => {
  const {
    formik,
    loader,
    contryStatus,
    changeCountry,
    openCity,
    handleOpenCity,
    handleCloseCity,
    handleFieldChange,
  } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>Update Standing User</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      User Name:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="userName"
                      placeholder="User Name"
                      value={formik.values.userName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("userName", e.target.value);
                      }}
                    />
                    {formik.errors.userName && formik.touched.userName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.userName}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Total Score:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="totalScore"
                      placeholder="Total Score"
                      value={formik.values.totalScore}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("totalScore", e.target.value);
                      }}
                    />
                    {formik.errors.totalScore && formik.touched.totalScore ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.totalScore}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Three LatterName:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="threeLatterName"
                      placeholder="Three LatterName"
                      value={formik.values.threeLatterName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("threeLatterName", e.target.value);
                      }}
                    />
                    {formik.errors.threeLatterName &&
                      formik.touched.threeLatterName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.threeLatterName}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Rank :
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="hashtagAssign"
                      placeholder="Three LatterName"
                      value={formik.values.hashtagAssign}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("hashtagAssign", e.target.value);
                      }}
                    />
                    {formik.errors.hashtagAssign &&
                      formik.touched.hashtagAssign ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.hashtagAssign}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Country : <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10"
                      options={contryStatus}
                      singleSelect
                      name="playerCountryName"
                      onChange={changeCountry}
                      isSearchable
                      menuIsOpen={openCity}
                      onMenuOpen={handleOpenCity}
                      onMenuClose={handleCloseCity}
                      value={contryStatus?.find(
                        (option) =>
                          option.label === formik.values.playerCountryName
                      )}
                    />
                    {formik.errors.playerCountryName &&
                      formik.touched.playerCountryName ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.playerCountryName}
                      </p>
                    ) : null}
                  </Form.Group>
                </div>

                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const AddColorCode = (props) => {
  const {
    formik,
    selectedType,
    loader,
    addNumbers,
    addNumber,
    removeNumber,
    handleChangeColor,
    handleTogglePicker,
    handleColorChange,
    colorPickerOpen,
    handleOk,
    showPicker,
    handleTextColorChange,
    handleTextTogglePicker,
    showPicker2,
    colorPickerOpen2,
    handleOk2,
    setAddNumbers,
    update,
  } = props;

  return (
    <Modal
      {...props}
      // size="large"
      dialogClassName="modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header
        onClick={() => {
          formik.resetForm();
          setAddNumbers(1);
        }}
        closeButton
      />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4> {update ? "Update Color Code" : "Add Color Code"}</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Season Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      disabled={update ? true : false}
                      type="text"
                      name="seasonName"
                      placeholder="Season Name"
                      value={formik.values.seasonName}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.seasonName && formik.touched.seasonName ? (
                      <p
                        className="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.seasonName}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Player Short Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    {[...Array(addNumbers)].map((_, index) => (
                      <>
                        <Form.Group
                          className="form-group"
                          key={index}
                          style={{ display: "flex" }}>
                          <div style={{ width: "40%" }}>
                            <Form.Control
                              type="text"
                              name="playerName"
                              placeholder="Player Short Name"
                              autocomplete="off"
                              auto
                              value={
                                formik.values.colorCodeDetail[index]?.playerName.toUpperCase()
                              }
                              style={{
                                backgroundColor:
                                  formik.values.colorCodeDetail[index]
                                    ?.colorCode,
                                color:
                                  formik.values.colorCodeDetail[index]
                                    ?.textColorCode,
                              }}
                              onChange={(event) => {
                                const inputValue = event.target.value
                                  ?.slice(0, selectedType === "moto_gp" ? 5 : 3)
                                  ?.toUpperCase();
                                handleChangeColor(index, event, inputValue);
                              }}
                              maxLength={selectedType === "moto_gp" ? 5 : 3}
                            />
                            {formik.errors.colorCodeDetail?.[index] &&
                              formik.touched.colorCodeDetail?.[index] ? (
                              <p
                                className="text-start error"
                                style={{ color: "red", textAlign: "start" }}>
                                {
                                  formik.errors.colorCodeDetail?.[index]
                                    ?.playerName
                                }
                              </p>
                            ) : null}
                          </div>
                          <div
                            style={{
                              width: "30%",
                              marginLeft: 0,
                            }}>
                            <div
                              onClick={() => handleTogglePicker(index)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                                marginLeft: "15px",
                                backgroundColor:
                                  formik.values.colorCodeDetail[index]
                                    ?.colorCode,
                                height: "38px",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}>
                              {formik.values.colorCodeDetail[index]
                                ?.colorCode === "" ? (
                                "Background Color"
                              ) : (
                                <FontAwesomeIcon
                                  icon={faPalette}
                                  name="colorCode"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            </div>
                            {formik.errors.colorCodeDetail?.[index] &&
                              formik.touched.colorCodeDetail?.[index] ? (
                              <p
                                classtype="text-start error"
                                style={{ color: "red", textAlign: "start" }}>
                                {
                                  formik.errors.colorCodeDetail?.[index]
                                    ?.colorCode
                                }
                              </p>
                            ) : null}
                            {showPicker && (
                              <>
                                {colorPickerOpen[index] && (
                                  <div className="color-pickers">
                                    <SketchPicker
                                      color={
                                        formik.values.colorCodeDetail[index]
                                          ?.colorCode
                                      }
                                      onChange={(newColor) =>
                                        handleColorChange(newColor, index)
                                      }
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                      }}>
                                      <Button
                                        style={{
                                          width: "75px",
                                        }}
                                        onClick={() => handleOk(index)}>
                                        OK
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                          <div
                            style={{
                              width: "30%",
                              marginLeft: 0,
                            }}>
                            <div
                              onClick={() => handleTextTogglePicker(index)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                                marginLeft: "15px",
                                backgroundColor:
                                  formik.values.colorCodeDetail[index]
                                    ?.textColorCode,
                                height: "38px",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}>
                              {formik.values.colorCodeDetail[index]
                                ?.textColorCode === "" ? (
                                "Text Color"
                              ) : (
                                <FontAwesomeIcon
                                  icon={faPalette}
                                  name="textColorCode"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            </div>
                            {formik.errors.colorCodeDetail?.[index] &&
                              formik.touched.colorCodeDetail?.[index] ? (
                              <p
                                classtype="text-start error"
                                style={{ color: "red", textAlign: "start" }}>
                                {
                                  formik.errors.colorCodeDetail?.[index]
                                    ?.textColorCode
                                }
                              </p>
                            ) : null}

                            {showPicker2 && (
                              <>
                                {colorPickerOpen2[index] && (
                                  <div className="color-pickers">
                                    <SketchPicker
                                      color={
                                        formik.values.colorCodeDetail[index]
                                          ?.textColorCode
                                      }
                                      onChange={(newColor) =>
                                        handleTextColorChange(newColor, index)
                                      }
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                      }}>
                                      <Button
                                        style={{
                                          width: "75px",
                                        }}
                                        onClick={() => handleOk2(index)}>
                                        OK
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                          {index === addNumbers - 1 ? (
                            <>
                              <button
                                style={{ height: "40px" }}
                                type="button"
                                className="btn btn-primary btn-sm ms-2"
                                onClick={addNumber}>
                                <i className="fa fa-plus"></i>
                              </button>
                              {index > 0 && (
                                <button
                                  style={{ height: "40px" }}
                                  type="button"
                                  className="btn btn-sm btn-danger ms-2"
                                  onClick={() => removeNumber(index)}>
                                  <i className="fa fa-times"></i>
                                </button>
                              )}
                            </>
                          ) : (
                            <button
                              style={{ height: "40px" }}
                              type="button"
                              className="btn btn-sm btn-danger ms-2"
                              onClick={() => removeNumber(index)}>
                              <i className="fa fa-times"></i>
                            </button>
                          )}
                        </Form.Group>
                      </>
                    ))}
                  </Form.Group>
                </div>

                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const RcaeResultEdit = (props) => {
  const {
    formik,
    loader,
    playerRaceDetailLength,
    handleFieldChange,
    handleChangeData,
    handleChangeData2,
  } = props;

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>Update Result User</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div style={{ width: "47%" }}>
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                          }}>
                          User Name:
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="userName"
                          placeholder="User Name"
                          value={formik.values.userName}
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("userName", e.target.value);
                          }}
                        />
                        {formik.errors.userName && formik.touched.userName ? (
                          <p className="text-start error">
                            {" "}
                            {formik.errors.userName}
                          </p>
                        ) : null}
                      </div>
                      <div style={{ width: "47%", marginLeft: "auto" }}>
                        <Form.Label
                          style={{
                            textAlign: "start",
                            color: "#000",
                            marginTop: "15px",
                          }}>
                          Total Score:
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="totalScore"
                          placeholder="Total Score"
                          value={formik.values.totalScore}
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("totalScore", e.target.value);
                          }}
                        />
                        {formik.errors.totalScore &&
                          formik.touched.totalScore ? (
                          <p className="text-start error">
                            {" "}
                            {formik.errors.totalScore}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    {[...Array(playerRaceDetailLength)].map((_, index) => (
                      <>
                        <div
                          style={{ display: "flex", justifyContent: "center" }}>
                          <div style={{ width: "47%" }}>
                            <Form.Label
                              style={{
                                textAlign: "start",
                                color: "#000",
                                marginTop: "15px",
                              }}>
                              {playerRaceDetailLength === 11 && index <= 9
                                ? `P${index + 1} (Race)`
                                : playerRaceDetailLength === 11 && index === 10
                                  ? "Fastest Lap"
                                  : playerRaceDetailLength === 18 && index < 8
                                    ? `P${index + 1} (Sprint)`
                                    : playerRaceDetailLength === 18 && index < 18
                                      ? `P${index + 1} (Race)`
                                      : playerRaceDetailLength === 19 && index < 8
                                        ? `P${index + 1} (Sprint)`
                                        : playerRaceDetailLength === 19 && index < 18
                                          ? `P${index - 7} (Race)`
                                          : "Fastest Lap"}
                            </Form.Label>

                            <Form.Control
                              type="text"
                              name="value"
                              placeholder={`P${index} Race`}
                              value={
                                formik.values.playerRaceDetail[index]?.value
                              }
                              onChange={(e) =>
                                handleChangeData(index, e.target.value)
                              }
                            />
                            {formik.errors.value && formik.touched.value ? (
                              <p className="text-start error">
                                {" "}
                                {formik.errors.value}
                              </p>
                            ) : null}
                          </div>
                          <div style={{ width: "47%", marginLeft: "auto" }}>
                            <Form.Label
                              style={{
                                textAlign: "start",
                                color: "#000",
                                marginTop: "15px",
                              }}>
                              {playerRaceDetailLength === 11 && index <= 9
                                ? `P${index + 1} (Race)`
                                : playerRaceDetailLength === 11 && index === 10
                                  ? "Fastest Lap"
                                  : playerRaceDetailLength === 18 && index < 8
                                    ? `P${index + 1} (Sprint)`
                                    : playerRaceDetailLength === 18 && index < 18
                                      ? `P${index + 1} (Race)`
                                      : playerRaceDetailLength === 19 && index < 8
                                        ? `P${index + 1} (Sprint)`
                                        : playerRaceDetailLength === 19 && index < 18
                                          ? `P${index - 7} (Race)`
                                          : "Fastest Lap"}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="scoreValue"
                              placeholder="Total Score"
                              value={
                                formik.values.playerRaceDetail[index]
                                  ?.scoreValue
                              }
                              onChange={(e) =>
                                handleChangeData2(index, e.target.value)
                              }
                            />
                            {formik.errors.scoreValue &&
                              formik.touched.scoreValue ? (
                              <p className="text-start error">
                                {" "}
                                {formik.errors.scoreValue}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ))}
                  </Form.Group>
                </div>

                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const HighScoreUpdate = (props) => {
  const {
    formik,
    loader,
    contryStatus,
    contryStatus2,
    changeCountry,
    changeCountry2,
    openCity,
    handleOpenCity,
    handleCloseCity,
    openCity2,
    handleOpenCity2,
    handleCloseCity2,
    handleFieldChange,
  } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>Update HighScore User</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      User Name:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="userName"
                      placeholder="User Name"
                      value={formik.values.userName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("userName", e.target.value);
                      }}
                    />
                    {formik.errors.userName && formik.touched.userName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.userName}
                      </p>
                    ) : null}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Total Score:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="score"
                      placeholder="Total Score"
                      value={formik.values.score}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("score", e.target.value);
                      }}
                    />
                    {formik.errors.score && formik.touched.score ? (
                      <p className="text-start error"> {formik.errors.score}</p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Player Three LatterName:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="playerThreeLatterName"
                      placeholder="Total Score"
                      value={formik.values.playerThreeLatterName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange(
                          "playerThreeLatterName",
                          e.target.value
                        );
                      }}
                    />
                    {formik.errors.playerThreeLatterName &&
                      formik.touched.playerThreeLatterName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.playerThreeLatterName}
                      </p>
                    ) : null}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Player Country :
                      <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10"
                      options={contryStatus}
                      singleSelect
                      name="playerCountry"
                      onChange={changeCountry}
                      isSearchable
                      menuIsOpen={openCity}
                      onMenuOpen={handleOpenCity}
                      onMenuClose={handleCloseCity}
                      value={contryStatus?.find(
                        (option) => option.label === formik.values.playerCountry
                      )}
                    />
                    {formik.errors.playerCountry &&
                      formik.touched.playerCountry ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.playerCountry}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Last RaceCountry :
                      <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10"
                      options={contryStatus2}
                      singleSelect
                      name="lastRaceCountry"
                      onChange={changeCountry2}
                      isSearchable
                      menuIsOpen={openCity2}
                      onMenuOpen={handleOpenCity2}
                      onMenuClose={handleCloseCity2}
                      value={contryStatus?.find(
                        (option) =>
                          option.label === formik.values.lastRaceCountry
                      )}
                    />
                    {formik.errors.lastRaceCountry &&
                      formik.touched.lastRaceCountry ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.lastRaceCountry}
                      </p>
                    ) : null}
                  </Form.Group>
                </div>

                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const HighScoreUpdateContinent = (props) => {
  const {
    formik,
    loader,
    contryStatus,
    contryStatus2,
    changeCountry,
    changeCountry2,
    openCity,
    handleOpenCity,
    handleCloseCity,
    openCity2,
    handleOpenCity2,
    handleCloseCity2,
    handleFieldChange,
    type,
  } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>Update HighScore User</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      User Name:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="userName"
                      placeholder="User Name"
                      value={formik.values.userName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("userName", e.target.value);
                      }}
                    />
                    {formik.errors.userName && formik.touched.userName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.userName}
                      </p>
                    ) : null}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Total Score:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="score"
                      placeholder="Total Score"
                      value={formik.values.score}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("score", e.target.value);
                      }}
                    />
                    {formik.errors.score && formik.touched.score ? (
                      <p className="text-start error"> {formik.errors.score}</p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      {type === "country" ? "Country Name" : "Continent Name"}:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={
                        type === "country" ? "Country Name" : "Continent Name"
                      }
                      value={formik.values.name}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange("name", e.target.value);
                      }}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <p className="text-start error"> {formik.errors.name}</p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Player Three LatterName:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="playerThreeLatterName"
                      placeholder="Total Score"
                      value={formik.values.playerThreeLatterName}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleFieldChange(
                          "playerThreeLatterName",
                          e.target.value
                        );
                      }}
                    />
                    {formik.errors.playerThreeLatterName &&
                      formik.touched.playerThreeLatterName ? (
                      <p className="text-start error">
                        {" "}
                        {formik.errors.playerThreeLatterName}
                      </p>
                    ) : null}

                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Player Country :
                      <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10"
                      options={contryStatus}
                      singleSelect
                      name="playerCountry"
                      onChange={changeCountry}
                      isSearchable
                      menuIsOpen={openCity}
                      onMenuOpen={handleOpenCity}
                      onMenuClose={handleCloseCity}
                      value={contryStatus?.find(
                        (option) => option.label === formik.values.playerCountry
                      )}
                    />
                    {formik.errors.playerCountry &&
                      formik.touched.playerCountry ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.playerCountry}
                      </p>
                    ) : null}
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Select Last RaceCountry :
                      <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10"
                      options={contryStatus2}
                      singleSelect
                      name="lastRaceCountry"
                      onChange={changeCountry2}
                      isSearchable
                      menuIsOpen={openCity2}
                      onMenuOpen={handleOpenCity2}
                      onMenuClose={handleCloseCity2}
                      value={contryStatus?.find(
                        (option) =>
                          option.label === formik.values.lastRaceCountry
                      )}
                    />
                    {formik.errors.lastRaceCountry &&
                      formik.touched.lastRaceCountry ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {formik.errors.lastRaceCountry}
                      </p>
                    ) : null}
                  </Form.Group>
                </div>

                <div>
                  <Button
                    type="submit"
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      marginRight: "15px",
                      marginTop: "15px",
                    }}>
                    Submit
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export function UploadRaceExcelFile(props) {
  const { showFileToSingleUpload, formik, loader, status, progress } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton={!loader} />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait</h4>
                <h6 className="text-danger mt-1">
                  Uploading in progress... so don't reload the page!
                </h6>

                <div
                  className="spinner-container"
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}>
                  <div>
                    <HashLoader color="#36D7B7" size={30} loading={true} />
                  </div>
                  <div
                    style={{
                      width: "100px",
                      marginTop: "10px",
                      height: "20px",
                      marginBottom: "10px",
                    }}>
                    {`${Math.round(progress)}%`}
                    <ProgressBar now={progress} aria-label="Loading progress" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <form onSubmit={formik.handleSubmit}>
                  <h4>Upload Race Result {status ? "11" : "19"}</h4>
                  <div className="col-12">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Form.Label className="text-start text-black font-weight-bold">
                        Download Excel File for Your Refrence Race Result 11 :
                      </Form.Label>
                      <Button
                        onClick={handleesultDownload}
                        style={{ marginLeft: "auto", marginRight: "15px" }}>
                        <i className="fas fa-download"></i> Download
                      </Button>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px",
                      }}>
                      <Form.Label className="text-start text-black font-weight-bold">
                        Download Excel File for Your Refrence Race Rusult 19 :
                      </Form.Label>
                      <Button
                        onClick={handleesult19Download}
                        style={{ marginLeft: "auto", marginRight: "15px" }}>
                        <i className="fas fa-download"></i> Download
                      </Button>
                    </div>
                    <Form.Group
                      controlid="validationFormik101"
                      className="position-relative">
                      <Form.Label className="text-start text-black mt-3">
                        File <span className="tx-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="data"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        placeholder="Choose a file"
                        onChange={(e) => showFileToSingleUpload(e)}
                      />

                      {formik.errors.data && formik.touched.data ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.data}
                        </p>
                      ) : null}
                    </Form.Group>
                  </div>

                  <div>
                    <Button
                      type="submit"
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "15px",
                        marginTop: "15px",
                      }}>
                      Submit
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function ConfirmationModal(props) {
  const { formik, onHide } = props;

  const cofirm = () => {
    onHide();
    formik.handleSubmit();
  };

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-warning  mg-t-20 "></i>

        <h4 className="tx-warning tx-semibold mg-b-20">Are You Sure!</h4>
        <p className="mg-b-20 mg-x-20">
          If you want to activate this particular race, any other active race
          should be finished !
        </p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            cofirm();
            formik.handleSubmit();
          }}>
          <Button onClick={cofirm} type="submit" variant="warning">
            Submit
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export function AddCountry(props) {
  const {
    showFileToUpload,
    selectedImages,
    formik,
    update,
    loader,
    showFileToUpload2,
  } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header
        closeButton
        onClick={(formik.resetForm, () => props.setSelectedImages(""))}
      />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <>
                <h4>{update ? "Update Country" : "Add Country"}</h4>
                <form onSubmit={formik.handleSubmit}>
                  <div className="col-12">
                    <Form.Group
                      controlid="validationFormik101"
                      className="position-relative">
                      <Form.Label
                        style={{
                          textAlign: "start",
                          color: "#000",
                          marginTop: "15px",
                        }}>
                        Country Name:
                        <span className="tx-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="countryName"
                        placeholder="Country"
                        value={formik.values.countryName}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          formik.handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                      />
                      {formik.errors.countryName &&
                        formik.touched.countryName ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.countryName}
                        </p>
                      ) : null}
                      <Form.Label className="text-start text-black mt-3">
                        Country File Square <span className="tx-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="files"
                        placeholder="Choose a file"
                        onChange={(e) => showFileToUpload(e)}
                      />
                      {formik.errors.files && formik.touched.files ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.files}
                        </p>
                      ) : null}
                      {selectedImages ? (
                        <>
                          <div
                            style={{
                              height: "250px",
                              width: "350px",
                            }}>
                            <img
                              src={selectedImages}
                              style={{ borderRadius: "11px" }}
                              alt={""}
                              className="img-fit-cover mt-3"
                            />
                          </div>
                        </>
                      ) : null}
                      <Form.Label className="text-start text-black mt-3">
                        Country File Aspect ratio 4 :3{" "}
                        <span className="tx-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="filesRatio"
                        placeholder="Choose a file"
                        onChange={(e) => showFileToUpload2(e)}
                      />
                      {formik.errors.filesRatio && formik.touched.filesRatio ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.filesRatio}
                        </p>
                      ) : null}
                    </Form.Group>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "15px",
                        marginTop: "15px",
                      }}>
                      {update ? "Update" : "Submit"}
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function AddWorldWide(props) {
  const { formik, showFileToSingleUpload, type, loader } = props;

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <>
                <form onSubmit={formik.handleSubmit}>
                  <h4>
                    Add{" "}
                    {type === "Middle East"
                      ? "Middle East"
                      : type === "worldwide"
                        ? "World Wide"
                        : type === "Africa"
                          ? "Africa"
                          : type === "Asia"
                            ? "Asia"
                            : type === "Europe"
                              ? "Europe"
                              : type === "North America"
                                ? "North America"
                                : type === "Oceania"
                                  ? "Oceania"
                                  : // :type === "South America"
                                  "South America"}
                    List
                  </h4>
                  <div className="col-12">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Form.Label className="text-start text-black font-weight-bold">
                        Download Excel File for Your Refrence :
                      </Form.Label>
                      <Button
                        className="text-white"
                        style={{ marginBottom: "5px" }}
                        onClick={
                          type === "continent"
                            ? continent
                            : type === "worldwide"
                              ? worldWide
                              : country
                        }>
                        <i className="fas fa-download"></i> &nbsp; Download
                        Excel Sheet
                      </Button>
                    </div>
                    <Form.Group
                      controlid="validationFormik101"
                      className="position-relative">
                      <Form.Label className="text-start text-black mt-3">
                        Upload{" "}
                        {type === "continent"
                          ? "Continent"
                          : type === "worldwide"
                            ? "World Wide"
                            : "Country "}{" "}
                        Excel File <span className="tx-danger"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="data"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        placeholder="Choose a file"
                        onChange={(e) => showFileToSingleUpload(e)}
                      />
                      {formik.errors.data && formik.touched.data ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.data}
                        </p>
                      ) : null}
                    </Form.Group>
                  </div>

                  <div>
                    <Button
                      type="submit"
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "15px",
                        marginTop: "15px",
                      }}>
                      Submit
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function AddStanding(props) {
  const { formik, handleFileUpload, loader, progress, getSeasonName } = props;
  // console.log("progress");

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton={!loader} />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait</h4>
                <h6 className="text-danger mt-1">
                  Uploading in progress... so don't reload the page!
                </h6>
                <div
                  className="spinner-container"
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}>
                  <div>
                    <HashLoader color="#36D7B7" size={30} loading={true} />
                  </div>
                  <div
                    style={{
                      width: "100px",
                      marginTop: "10px",
                      height: "20px",
                      marginBottom: "10px",
                    }}>
                    {`${Math.round(progress)}%`}
                    <ProgressBar
                      now={progress}
                      // label={`${Math.round(progress)}%`}
                      aria-label="Loading progress"
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <h4>Add Standing List  </h4>
                <form onSubmit={formik.handleSubmit}>
                  <div className="col-12">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Form.Label className="text-start text-black font-weight-bold">
                        Download Excel File for Your Refrence :
                      </Form.Label>
                      <Button
                        className="text-white"
                        style={{ marginBottom: "5px" }}
                        onClick={downloadStanding}>
                        <i className="fas fa-download"></i> &nbsp; Download
                        Excel Sheet
                      </Button>
                    </div>

                    <Form.Group
                      controlid="validationFormik101"
                      className="position-relative">

                      <Form.Label className="text-start text-black">
                        Select Season Name <span className="tx-danger"> *</span>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="season"
                        value={formik.values.season}
                        onChange={formik.handleChange}
                        className="form-control">
                        <option value="">Choose a season...</option>
                        {getSeasonName && getSeasonName.map((season, index) => (
                          <option key={index} value={season}>
                            {season}
                          </option>
                        ))}
                      </Form.Control>
                      {formik.errors.season && formik.touched.season ? (
                        <p
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.season}
                        </p>
                      ) : null}

                      <Form.Label className="text-start text-black mt-3">
                        Upload Standing Excel File{" "}
                        <span className="tx-danger"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="data"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        placeholder="Choose a file"
                        onChange={(e) => handleFileUpload(e)}
                      />
                      {formik.errors.data && formik.touched.data ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.data}
                        </p>
                      ) : null}
                    </Form.Group>
                  </div>

                  <div>
                    <Button
                      type="submit"
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "15px",
                        marginTop: "15px",
                      }}>
                      Submit
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function AddSeasons(props) {
  const { formik, handleFileUpload, loader, seasonsListData } = props;

  const currentYear = new Date().getFullYear();

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header onClick={formik.resetForm} closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <>
                <h4>Add Seasons List </h4>
                <form onSubmit={formik.handleSubmit}>
                  <div className="col-12">
                    <Form.Group
                      controlid="validationFormik101"
                      className="position-relative">
                      <Form.Label className="text-start text-black mt-3">
                        Upload Seasons Excel File{" "}
                        <span className="tx-danger"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="data"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        placeholder="Choose a file"
                        onChange={(e) => handleFileUpload(e)}
                      />
                      {formik.errors.data && formik.touched.data ? (
                        <p
                          classtype="text-start error"
                          style={{ color: "red", textAlign: "start" }}>
                          {formik.errors.data}
                        </p>
                      ) : null}
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Label className="text-start text-black mt-3">
                      Season <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2 z-index-10 pointer "
                      options={seasonsListData?.map((item) => ({
                        label: item?.name,
                        value: item?._id,
                      }))}
                      singleSelect
                      name="season"
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          formik.setFieldValue("season", selectedOption.value);
                        }
                      }}
                      isSearchable
                    />
                  </div>
                  {formik.errors.season && formik.touched.season ? (
                    <p
                      className="text-start error"
                      style={{
                        color: "#dc3545",
                        fontSize: "0.875rem",
                        marginTop: "5px",
                        marginLeft: "15px",
                      }}>
                      {formik.errors.season}
                    </p>
                  ) : null}
                  <div>
                    <Button
                      type="submit"
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "15px",
                        marginTop: "15px",
                      }}>
                      Submit
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export function AddContinent(props) {
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {/* <form onSubmit={formik.handleSubmit}> */}
            <h4>Add Continent List</h4>
            <div className="col-12">
              <Form.Group
                controlid="validationFormik101"
                className="position-relative">
                <Form.Label className="text-start text-black mt-3">
                  Upload Continent Excel File{" "}
                  <span className="tx-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="image"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  placeholder="Choose a file"
                />
              </Form.Group>
            </div>

            <div>
              <Button
                type="submit"
                style={{
                  display: "flex",
                  marginLeft: "auto",
                  marginRight: "15px",
                  marginTop: "15px",
                }}>
                Submit
              </Button>
            </div>
            {/* </form> */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

// all delete modal

export const DeleteCountryModule = (props) => {
  const { id, name, GetCountryData, onHide } = props;
  const [loader, setLoader] = useState(false);

  const deleteCountry = async () => {
    setLoader(true);
    await CountryService.DeleteCountry(id);
    GetCountryData();
    onHide();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {name} Country !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteCountry}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteHighScore = (props) => {
  const { onHide, getAllHighScore, type } = props;
  const [loader, setLoader] = useState(false);

  const deleteCountry = async () => {
    setLoader(true);
    await HighScoreService.DeleteHighScore(type);
    onHide();
    getAllHighScore();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {type} Data !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteCountry}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteColorCode = (props) => {
  const { onHide, getAllStanding, deleteId, season } = props;
  const [loader, setLoader] = useState(false);

  const deleteCountry = async () => {
    setLoader(true);
    await ColorCodeService.DeleteColorCode(deleteId);
    onHide();
    getAllStanding();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {season} Season !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteCountry}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteHighScoreSingle = (props) => {
  const { onHide, getAllHighScore, type, id, name } = props;
  const [loader, setLoader] = useState(false);

  // const deleteCountry = async () => {
  //   setLoader(true);
  //   await HighScoreService.DeleteHighScore(type);
  //   getAllHighScore();
  //   onHide();
  //   setLoader(false);
  // };
  const handleDelete = async () => {
    setLoader(true);
    await HighScoreService.DeleteHighScoreSingle(type, id);
    onHide();
    setLoader(false);
    getAllHighScore();
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {name} Data !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteAllRaceResult = (props) => {
  const { onHide, getAllHighScore, id, name } = props;
  const [loader, setLoader] = useState(false);

  // const deleteCountry = async () => {
  //   setLoader(true);
  //   await HighScoreService.DeleteHighScore(type);
  //   getAllHighScore();
  //   onHide();
  //   setLoader(false);
  // };
  const handleDelete = async () => {
    setLoader(true);
    await RaceService.raceResultDelete(id, "result");
    onHide();
    setLoader(false);
    getAllHighScore();
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {name} Data !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteRaceModule = (props) => {
  const { id, name, getAllData, onHide } = props;
  const [loader, setLoader] = useState(false);

  const deleteRace = async () => {
    setLoader(true);
    await RaceService.DeleteRace(id);
    getAllData();
    onHide();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {name} Race !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteRace}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteRaceResult = (props) => {
  const { onHide, id, getAllResult } = props;
  const [loader, setLoader] = useState(false);

  const deleteRace = async () => {
    setLoader(true);
    await RaceService.raceResultDelete(id, "single");
    onHide();
    getAllResult();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete Race Result !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteRace}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteFeedback = (props) => {
  const { onHide, id, getAllFeedback } = props;
  const [loader, setLoader] = useState(false);

  const deleteRace = async () => {
    setLoader(true);
    await FeedbackService.DeleteFeedback(id);
    onHide();
    getAllFeedback();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete Feedback !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteRace}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteUser = (props) => {
  const { onHide, id, getAllUser, name } = props;
  const [loader, setLoader] = useState(false);

  const deleteUser = async () => {
    setLoader(true);
    await UserService.UserDelete(id);
    onHide();
    getAllUser();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {name} user !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteUser}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteSeasonList = (props) => {
  const { onHide, id, getAllSeasons } = props;
  const [loader, setLoader] = useState(false);

  const deleteSeasonList = async () => {
    try {
      setLoader(true);
      await SeasonsService.deleteSeasonsList(id);
      enqueueSnackbar("SeasonList deleted successfully", {
        variant: "success",
      });
      onHide();
      getAllSeasons();
      setLoader(false);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          Are you sure want to delete this SeasonList !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteSeasonList}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteGroup = (props) => {
  const { onHide, id, getAllGroups, name } = props;
  const [loader, setLoader] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const deleteGroup = async () => {
    try {
      setLoader(true);
      await GroupService.deleteGroup(id);
      onHide();
      getAllGroups();
      setLoader(false);
      enqueueSnackbar("Group Deleted successfully!", { variant: "success" });
    } catch (error) {
      console.error("not able to delete group", error);
      enqueueSnackbar(`Something went wrong! :${error.response.data.message}`, {
        variant: "error",
      });
    }
  };

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          Are you sure want to delete {name} Group !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteGroup}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteGroupMember = (props) => {
  const { onHide, memberId, getGroupMembers, name, groupId } = props;
  const [loader, setLoader] = useState(false);

  const deleteGroup = async () => {
    try {
      setLoader(true);
      await GroupService.removeMemberFromGroup(groupId, memberId);
      onHide();
      getGroupMembers();
      setLoader(false);
      enqueueSnackbar("Member deleted successfully!", { variant: "success" });
    } catch (error) {
      console.error("not able to delete groupmember", error);
      enqueueSnackbar(`Something went wrong! :${error.response.data.message}`, {
        variant: "error",
      });
      setLoader(false);
    }
  };

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          Are you sure want to delete {name} as a groupmember !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteGroup}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteCountryCode = (props) => {
  const { onHide, id, getAllUser, name } = props;
  const [loader, setLoader] = useState(false);

  const deleteUser = async () => {
    setLoader(true);
    await CountryCodeService.CountryCodeDelete(id);
    onHide();
    getAllUser();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {name} user !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteUser}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteStandingModule = (props) => {
  const { getAllStanding, onHide, selectedType } = props;
  const [loader, setLoader] = useState(false);

  const deleteRace = async () => {
    setLoader(true);
    await StandingService.DeleteAllStanding(selectedType.toUpperCase());
    getAllStanding();
    onHide();
    setLoader(false);
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete All Standing Data !!
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteRace}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeleteSeasonsModule = (props) => {
  const { getAllSeasons, onHide, formik, seasonsListData } = props;
  const [selectedSeason, setSelectedSeason] = useState("");
  const [seasonError, setSeasonError] = useState(false);
  const [loader, setLoader] = useState(false);

  const deleteSeason = async () => {
    if (selectedSeason === "") {
      setSeasonError(true);
      return;
    }
    try {
      setLoader(true);
      await SeasonsService.deleteAllSeasonsData(selectedSeason);
      enqueueSnackbar("Season's data deleted successfully", {
        variant: "success",
      });
      getAllSeasons();
      onHide();
      setLoader(false);
    } catch (error) {
      console.error("error");
      enqueueSnackbar("Something went wrong", {
        variant: "error",
      });
      setLoader(false);
    }
  };

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold">Delete !</h4>

        <div className={seasonError ? `col-12 mg-b-5` : "`col-12 mg-b-20"}>
          <Form.Label className="text-start text-black">
            Season <span className="tx-danger"> *</span>
          </Form.Label>
          <Multiselect
            classNamePrefix="Select2 z-index-10 pointer "
            options={seasonsListData?.map((item) => ({
              label: item?.name,
              value: item?._id,
            }))}
            singleSelect
            name="season"
            onChange={(selectedOption) => {
              if (selectedOption) {
                setSeasonError(false);
                setSelectedSeason(selectedOption.value);
              }
            }}
            isSearchable
          />
        </div>
        {seasonError ? (
          <p
            className="text-start error"
            style={{
              color: "#dc3545",
              fontSize: "0.875rem",
              marginLeft: "15px",
            }}>
            {"Please select season to delete seasons's Data!"}
          </p>
        ) : null}
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteSeason}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const DeletePlayer = (props) => {
  const { id, playerName, onHide, playerId, getPlayer } = props;
  const [loader, setLoader] = useState(false);

  const { handleClose: handleDialogClose } = useDialogState();

  const deleteRace = async () => {
    setLoader(true);
    // const response = await RaceService.GetSingleRace(id);
    // const result = response.data.data;
    try {
      // const updatedPlayerDetail = result.playerDetail.filter(
      //   (player) => player._id !== playerId
      // );

      // const updatedResult = {
      //   raceStatus: result.raceStatus,
      //   data: updatedPlayerDetail,
      //   type: selectedType?.toUpperCase(),
      // };

      await RaceService.deletePlayerFromRace(id, playerId);
      onHide();
      getPlayer();
      setLoader(false);
      handleDialogClose();
      enqueueSnackbar("Player Delete Successfully", {
        variant: "success",
      });
    } catch (error) {
      console.error("errorr", error);
      enqueueSnackbar("Something Wrong", {
        variant: "error",
      });
    }
  };
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <i className="icon ion-ios-checkmark-circle-outline tx-100 tx-danger  mg-t-20 "></i>

        <h4 className="tx-danger tx-semibold mg-b-20">Delete !</h4>
        <p className="mg-b-20 mg-x-20 ">
          are you sure want to delete {playerName} player !!``
        </p>
        {loader ? (
          <>
            <div className="spinner-container" style={{ marginTop: "40px" }}>
              <HashLoader color="#FF0000" size={30} loading={true} />
            </div>
          </>
        ) : (
          <Button variant="danger" onClick={deleteRace}>
            Delete
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export const StatusModule = (props) => {
  const {
    id,
    onHide,
    name,
    raceStatus,
    getAllData,
    openCity,
    handleOpenCity,
    handleCloseCity,
  } = props;
  const [loader, setLoader] = useState(false);
  const [statusUpdate, setStatusUpdate] = useState("");

  const UpdateStatus = async () => {
    setLoader(true);
    await RaceService.UpdateRace(id, statusUpdate);
    onHide();
    getAllData();
    setLoader(false);
  };

  const initialValue = {
    raceStatus: "",
  };

  const handelStatusChange = (value) => {
    setStatusUpdate(value.value);
    formik.setFieldValue("raceStatus", value.value);
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: UpdateStatus,
  });
  const filteredOptions =
    formik.values.raceStatus === "active"
      ? raceStatus.filter((option) => option.value === "finished")
      : raceStatus;

  useEffect(() => {
    formik.setFieldValue("raceStatus", name);
  }, []);
  const [modalShow, setModalShow] = useState(false);

  const handleConfirmation = () => {
    setModalShow(true);
  };
  const handleDialogClose = () => {
    setModalShow(false);
  };

  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <>
                <h4>Race Status</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Race Status : <span className="tx-danger"> *</span>
                    </Form.Label>
                    <Multiselect
                      classNamePrefix="Select2"
                      options={filteredOptions}
                      singleSelect
                      displayValue="key"
                      name="raceStatus"
                      menuIsOpen={openCity}
                      onMenuOpen={handleOpenCity}
                      onMenuClose={handleCloseCity}
                      value={raceStatus?.find(
                        (option) => option.value === formik.values.raceStatus
                      )}
                      onChange={handelStatusChange}
                    />
                    {formik.errors.raceStatus && formik.touched.raceStatus ? (
                      <p
                        classtype="text-start error"
                        style={{ color: "red", textAlign: "start" }}>
                        {" "}
                        {formik.errors.raceStatus}
                      </p>
                    ) : null}
                  </Form.Group>
                </div>

                <Button
                  onClick={handleConfirmation}
                  style={{
                    display: "flex",
                    marginLeft: "auto",
                    marginRight: "15px",
                    marginTop: "15px",
                  }}>
                  Submit
                </Button>
              </>
            )}
            {modalShow && (
              <ConfirmationModal
                show={modalShow}
                onHide={() => {
                  handleDialogClose();
                }}
                formik={formik}
              />
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const GroupEdit = (props) => {
  const { formik, loader, error, setError, onHide, handleFieldChange, update, setGroupCodeError, groupCodeError } =
    props;
  return (
    <Modal
      {...props}
      size="large"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static">
      <Modal.Header
        onHide={() => {
          formik.resetForm();
          onHide();
        }}
        closeButton
      />
      <Modal.Body className="text-center">
        <div className="col-122">
          <div className="card custom-card">
            {loader ? (
              <>
                <h4>Please Wait </h4>
                <div
                  className="spinner-container"
                  style={{ marginTop: "40px" }}>
                  <HashLoader color="#36D7B7" size={30} loading={true} />
                </div>
              </>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <h4>{update ? "Update Group" : "Add Group"}</h4>
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Group Name<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Group Name"
                      value={formik.values.name}
                      onChange={(e) => {
                        if (e.target.value.length !== 0) {
                          setError(false);
                        }
                        formik.handleChange(e);
                        handleFieldChange("name", e.target.value);
                      }}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <p className="text-start error">{formik.errors.name}</p>
                    ) : null}
                  </Form.Group>
                </div>
                {error && (
                  <p
                    style={{
                      color: "red",
                      margin: 0,
                      justifyContent: "start",
                      display: "flex",
                      marginLeft: "15px",
                    }}>
                    Please enter group name!
                  </p>
                )}
                <div className="col-12">
                  <Form.Group
                    controlid="validationFormik101"
                    className="position-relative">
                    <Form.Label
                      style={{
                        textAlign: "start",
                        color: "#000",
                        marginTop: "15px",
                      }}>
                      Group Code<span className="tx-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="groupCode"
                      placeholder="Group Code"
                      value={formik.values.groupCode}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setGroupCodeError("");
                        handleFieldChange("groupCode", e.target.value);
                      }}
                    />
                    {formik.errors.groupCode && formik.touched.groupCode ? (
                      <p className="text-start error">{formik.errors.groupCode}</p>
                    ) : null}
                  </Form.Group>
                </div>
                {groupCodeError && (
                  <p
                    style={{
                      color: "red",
                      margin: 0,
                      justifyContent: "start",
                      display: "flex",
                      marginLeft: "15px",
                    }}>
                    {groupCodeError}
                  </p>
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginTop: "15px",
                    gap: "190px",
                  }}>
                  <div>
                    <Button type="submit">Submit</Button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
